export const BASEPOINT_EBAY_URL = 'https://www.ebay.com/itm/960101007246';
